export default (params) => ({
  trigger: {
    name: 'order_status_element.click_order',
    params: params,
  },
  config: {
    schema: {
      order_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'select_order',
      params: {
        sub_feature: null,
        index: null,
        total_indices: null,
        method: null,
      },
    },
  },
});
